/* MGH 07/10/2026 (revisto a 08/10/2026): validação do e-mail em TODOS os campos de email do site
   (newsletter do rodapé, faixa de subscrição, página do cupão, formulário de contacto e qualquer outro
   input type="email" do tema, mesmo os que aparecem depois de a página carregar).
   Carregado em snippets/mgh-custom-css.liquid, que o rodapé inclui em todas as páginas.
   1) Formato completo nome@dominio.tld (bloqueia o envio).
   2) Domínio que não existe ou não recebe email (bloqueia o envio). Pergunta ao DNS público da Google
      (dns.google) se o domínio tem servidor de correio. Só é enviado o domínio, nunca o email completo.
      Se a consulta falhar ou ainda não tiver chegado, o envio não é bloqueado.
   3) Domínio parecido com um fornecedor conhecido (gmial.pt, mial.pt, hotmal.com, gmail.con...): mostra
      "Querias escrever ...?". No primeiro envio o formulário para e mostra a sugestão; se a pessoa enviar outra
      vez o mesmo email, segue (há domínios verdadeiros parecidos com os conhecidos, por exemplo mial.pt existe).
   O envio é verificado na janela, em fase de captura, para correr antes de qualquer outro script
   (por exemplo a proteção anti-spam da Shopify, que também interceta o envio dos formulários).
   Para acrescentar fornecedores, editar "fornecedores"; domínios verdadeiros que sejam confundidos vão para "validos".
   Para deixar um campo de fora, pôr-lhe o atributo data-mgh-email="off".
   Não chega ao checkout nem à área de cliente (account.multiversegeekhouse.pt), que são páginas da Shopify. */
(function () {
  // Domínios exatos com erro conhecido (inclui fornecedor certo com terminação errada)
  var typos = {
    'gmail.co': 'gmail.com', 'gmail.pt': 'gmail.com', 'sapo.p': 'sapo.pt', 'sapo.com': 'sapo.pt',
    'icloud.pt': 'icloud.com', 'hotmail.pt': 'hotmail.com'
  };
  // Terminações que não existem e são quase sempre engano
  var tldErrados = { con: 'com', cmo: 'com', ocm: 'com', vom: 'com', xom: 'com', cim: 'com', comm: 'com', coom: 'com', ptt: 'pt' };
  // Fornecedores comuns: nome, terminação principal e outras terminações que existem mesmo
  var fornecedores = [
    { nome: 'gmail', tld: 'com', outros: [] },
    { nome: 'hotmail', tld: 'com', outros: ['fr', 'es', 'it', 'de', 'co.uk', 'com.br'] },
    { nome: 'outlook', tld: 'com', outros: ['pt', 'es', 'fr', 'it', 'de', 'com.br'] },
    { nome: 'yahoo', tld: 'com', outros: ['fr', 'es', 'it', 'de', 'co.uk', 'com.br'] },
    { nome: 'icloud', tld: 'com', outros: [] },
    { nome: 'protonmail', tld: 'com', outros: ['ch'] }
  ];
  // Domínios verdadeiros parecidos com os de cima: nunca sugerir correção
  var validos = ['gmx.com', 'gmx.pt', 'ymail.com', 'proton.me', 'me.com', 'msn.com', 'live.com', 'live.com.pt', 'sapo.pt'];
  // Nomes genéricos usados por fornecedores verdadeiros (mail.com, mail.ru, email.com...): nunca comparar por semelhança
  var nomesLivres = ['mail', 'email'];
  var ERRO = 'Escreve um email válido, por exemplo nome@exemplo.pt';
  var SELETOR = 'input[type="email"]:not([data-mgh-email="off"])';

  function emailValido(v) {
    if (!v || v.length > 254) return false;
    if (!/^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(v)) return false;
    var partes = v.split('@');
    var local = partes[0];
    if (local.indexOf('..') !== -1 || local.charAt(0) === '.' || local.charAt(local.length - 1) === '.') return false;
    var labels = partes[1].split('.');
    return /^[A-Za-z]{2,}$/.test(labels[labels.length - 1]);
  }

  // Distância de edição (conta a troca de duas letras vizinhas como 1 erro)
  function distancia(a, b) {
    var d = [];
    for (var i = 0; i <= a.length; i++) {
      d[i] = [i];
      for (var j = 1; j <= b.length; j++) {
        if (i === 0) { d[0][j] = j; continue; }
        var custo = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + custo);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[a.length][b.length];
  }

  // Devolve o domínio corrigido, ou null se não há nada a sugerir
  function sugerirDominio(dominio) {
    var d = dominio.toLowerCase();
    if (typos[d]) return typos[d];
    var labels = d.split('.');
    var ultimo = labels.length - 1;
    if (tldErrados[labels[ultimo]]) labels[ultimo] = tldErrados[labels[ultimo]];
    var d2 = labels.join('.');
    var base = d2 !== d ? d2 : null;
    if (typos[d2]) return typos[d2];
    if (validos.indexOf(d2) !== -1) return base;
    var nome = labels[0];
    var resto = labels.slice(1).join('.');
    if (nomesLivres.indexOf(nome) !== -1) return base;
    var i;
    for (i = 0; i < fornecedores.length; i++) {
      if (fornecedores[i].nome === nome) return base;
    }
    // Semelhança: até 2 letras de diferença. Só em domínios simples (nome.pt, nome.com) ou com uma terminação
    // que o fornecedor usa mesmo, para não apanhar subdomínios de organismos (ex.: mai.gov.pt).
    var melhor = null;
    var menor = 3;
    for (i = 0; i < fornecedores.length; i++) {
      var f = fornecedores[i];
      if (labels.length > 2 && f.outros.indexOf(resto) === -1) continue;
      var dist = distancia(nome, f.nome);
      if (dist < menor) { menor = dist; melhor = f; }
    }
    if (melhor) return melhor.nome + '.' + (melhor.outros.indexOf(resto) !== -1 ? resto : melhor.tld);
    return base;
  }

  // Consulta ao DNS: o domínio existe e recebe email? Resultado: 'ok', 'mau' ou '' (não se sabe)
  var dnsPedidos = {};
  var dnsResultado = {};

  function consultar(tipo, dominio) {
    return fetch('https://dns.google/resolve?name=' + encodeURIComponent(dominio) + '&type=' + tipo).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function estadoDominio(dominio) {
    var d = dominio.toLowerCase();
    if (!window.fetch || !window.Promise) return null;
    if (!dnsPedidos[d]) {
      dnsPedidos[d] = consultar('MX', d).then(function (j) {
        if (!j) return '';
        if (j.Status === 3) return 'mau';
        if (j.Status !== 0) return '';
        var mx = (j.Answer || []).filter(function (a) { return a.type === 15; });
        if (mx.length) {
          var soNulo = mx.every(function (a) { return /^\d+\s+\.$/.test(a.data); });
          return soNulo ? 'mau' : 'ok';
        }
        // Sem servidor de correio declarado: ainda pode receber email se o domínio tiver endereço próprio
        return consultar('A', d).then(function (k) {
          if (!k || (k.Status !== 0 && k.Status !== 3)) return '';
          return (k.Answer || []).some(function (a) { return a.type === 1; }) ? 'ok' : 'mau';
        });
      }).catch(function () {
        return '';
      }).then(function (r) {
        if (r) dnsResultado[d] = r;
        else delete dnsPedidos[d];
        return r;
      });
    }
    return dnsPedidos[d];
  }

  function erroDominio(d) {
    return 'O domínio "' + d + '" não existe ou não recebe email. Confirma se o teu email está bem escrito.';
  }

  function ligar(email) {
    if (!email.form || email.getAttribute('data-mgh-email')) return;
    email.setAttribute('data-mgh-email', '1');
    var vazio = 'Indica o teu email';
    if (email.id === 'mgh-cupao-email') vazio = 'Indica o teu email para receberes o código';
    else if (email.closest('.newsletter-form')) vazio = 'Indica o teu email para receberes as novidades';

    var dica = document.createElement('p');
    dica.className = 'mgh-email-dica';
    dica.setAttribute('role', 'status');
    dica.style.display = 'none';
    (email.closest('.field') || email).insertAdjacentElement('afterend', dica);
    var atual = '';
    var aceite = '';
    var espera = null;

    function esconder() {
      atual = '';
      dica.style.display = 'none';
      dica.textContent = '';
    }

    function dominioDe(v) {
      return emailValido(v) ? v.split('@')[1].toLowerCase() : '';
    }

    function sugestaoPara(v) {
      if (!emailValido(v)) return '';
      var p = v.split('@');
      var certo = sugerirDominio(p[1]);
      return certo ? p[0] + '@' + certo : '';
    }

    function mostrar(sugestao, aviso) {
      // Se a mesma sugestão já está visível não se volta a criar, para o clique nela não se perder
      if (sugestao === atual && !aviso) return;
      esconder();
      atual = sugestao;
      var botao = document.createElement('button');
      botao.type = 'button';
      botao.textContent = sugestao;
      botao.addEventListener('click', function () {
        email.value = sugestao;
        verificar();
        email.focus();
      });
      dica.appendChild(document.createTextNode('Querias escrever '));
      dica.appendChild(botao);
      dica.appendChild(document.createTextNode(aviso ? '? Se o teu email está certo, envia outra vez.' : '?'));
      dica.style.display = 'block';
    }

    // Pergunta ao DNS pelo domínio escrito. Com "avisar", mostra o erro se o domínio não existir.
    function verificarDns(avisar) {
      var v = email.value.trim().toLowerCase();
      var d = dominioDe(v);
      if (!d) return;
      var pedido = estadoDominio(d);
      if (!pedido || !avisar) return;
      pedido.then(function (r) {
        if (r !== 'mau' || email.value.trim().toLowerCase() !== v) return;
        email.setCustomValidity(erroDominio(d));
        if (!atual) {
          dica.textContent = erroDominio(d);
          dica.style.display = 'block';
        }
      });
    }

    function verificar() {
      var v = email.value.trim();
      email.setCustomValidity(!v || emailValido(v) ? '' : ERRO);
      var sugestao = sugestaoPara(v);
      if (sugestao) mostrar(sugestao, false);
      else esconder();
      verificarDns(true);
    }

    email.addEventListener('input', function () {
      email.setCustomValidity('');
      // Adianta a consulta ao DNS enquanto a pessoa escreve, para já haver resposta se enviar com Enter
      clearTimeout(espera);
      espera = setTimeout(function () { verificarDns(false); }, 600);
    });
    email.addEventListener('blur', verificar);
    email.addEventListener('invalid', function () {
      if (!email.value && email.required) email.setCustomValidity(vazio);
    });

    // Chamado no envio do formulário. Devolve true se o envio deve parar.
    email.mghTravarEnvio = function () {
      if (!email.value.trim() && !email.required) return false;
      email.value = email.value.trim().toLowerCase();
      var ok = emailValido(email.value);
      email.setCustomValidity(ok ? '' : ERRO);
      if (!ok) {
        email.reportValidity();
        return true;
      }
      var d = dominioDe(email.value);
      var sugestao = sugestaoPara(email.value);
      if (dnsResultado[d] === 'mau') {
        email.setCustomValidity(erroDominio(d));
        if (sugestao) mostrar(sugestao, false);
        email.reportValidity();
        return true;
      }
      if (sugestao && aceite !== email.value) {
        // Primeiro envio com um domínio suspeito: para e mostra a sugestão. O segundo envio do mesmo email segue.
        aceite = email.value;
        mostrar(sugestao, true);
        email.focus();
        return true;
      }
      return false;
    };
  }

  document.querySelectorAll(SELETOR).forEach(ligar);
  // Campos que só aparecem depois (janelas, gavetas, apps): ligam-se quando recebem o foco
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.matches && e.target.matches(SELETOR)) ligar(e.target);
  });
  // Envio: verificado antes de todos os outros scripts da página
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelectorAll) return;
    var travar = false;
    form.querySelectorAll(SELETOR).forEach(function (email) {
      ligar(email);
      if (!travar && email.mghTravarEnvio && email.mghTravarEnvio()) travar = true;
    });
    if (travar) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
})();
